import { FC, PropsWithChildren, ReactElement } from "react";

type Props = {
  condition: boolean;
  tooltip: (children: ReactElement) => ReactElement;
  children: ReactElement;
};

const SearchBtnTooltip: FC<PropsWithChildren<Props>> = ({
  condition,
  tooltip,
  children
}) => (condition ? tooltip(children) : children);

export default SearchBtnTooltip;
